export const environment = {
  production: true,
  baseUrl:'https://dlo-kbapi-ns-prod.azurewebsites.net/api',
  dloLoginUrl:'https://delllicensingonline.com/',
  retryCount:4,
  retryTimer:3000,
  clientId:'9C984156-FAC4-4332-B57F-C69FF2899EDC',
  chunkSizeMB:10
  
};
